import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    snackbar: {
      visible: false,
      text: null,
      color: '',
      timeout: 3000
    },
    navigation: false,
    autorized: false
  },
  mutations: {
    showSnackbar (state, payload) {
      state.snackbar.text = payload.text
      state.snackbar.color = payload.color
      state.snackbar.visible = true
    },
    showNavigation (state) {
      state.navigation = true
    },
    hideNavigation (state) {
      state.navigation = false
    },
    appLogin (state) {
      state.autorized = true
    },
    appLogout (state) {
      state.autorized = false
      router.push('/auth')
    }
  },
  actions: {
    appLogin (context) {
      context.commit('appLogin')
    },
    appLogout (context) {
      window.$cookies.remove('evr_jwt')
      // window.FB.logout(res => {
      //   // console.log('FB logout')
      //   // console.log(res)
      // })
      context.commit('appLogout')
    },
    showSnackbar (context, payload) {
      context.commit('showSnackbar', payload)
    },
    showSuccessSnackbar (context, message) {
      context.commit('showSnackbar', {
        text: message,
        color: 'success'
      })
    },
    handleError (context, payload) {
      let message
      if (payload.status === 401) {
        message = 'Вам необходимо авторизироваться чтобы продолжить'
        context.commit('appLogout')
      } else {
        message = payload.data
      }
      context.commit('showSnackbar', {
        text: message,
        color: 'error'
      })
    }
  }
})
